// AB   ASH-009
// Progressive enhancement for product upsells

document.addEventListener('DOMContentLoaded', () => {
  const upsellsContainer = document.querySelector('.product-upsells--ab');
  if (!upsellsContainer) return;

  // Enable the hidden variant inputs (they start disabled to prevent form submission issues)
  const variantInputs = upsellsContainer.querySelectorAll('.product-upsell-card__variant-input');
  variantInputs.forEach(input => {
    input.disabled = false;
  });

  // Handle variant selector changes to update hidden variant ID input
  const variantSelects = upsellsContainer.querySelectorAll('.product-upsell-card__variant-select');
  
  variantSelects.forEach((select) => {
    const productId = select.dataset.productId;
    const card = select.closest('.product-upsell-card');
    const productHandle = card?.dataset.productHandle;
    const variantInput = card?.querySelector('.product-upsell-card__variant-input');
    const atcButton = card?.querySelector('.product-upsell-card__atc-button');
    const atcText = card?.querySelector('.product-upsell-card__atc-text');
    const variantSelector = select.closest('.product-upsell-card__variant-selector');
    
    // Add arrow rotation on select open/close
    if (variantSelector) {
      select.addEventListener('mousedown', () => {
        variantSelector.classList.toggle('is-open');
      });
      
      select.addEventListener('blur', () => {
        variantSelector.classList.remove('is-open');
      });
      
      select.addEventListener('change', () => {
        variantSelector.classList.remove('is-open');
      });
    }
    
    // Fetch product data on page load to build variant map
    if (productHandle && variantInput) {
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          // Store variants on the select element for quick access
          select.dataset.variants = JSON.stringify(product.variants);
          
          // Set initial variant based on current selection
          updateVariantId(select, variantInput, atcButton, atcText);
        })
        .catch(err => console.error('Error fetching product:', err));
    }
    
    // Update variant ID when selection changes
    select.addEventListener('change', (e) => {
      updateVariantId(select, variantInput, atcButton, atcText);
    });
  });
  
  // Function to update variant ID based on selected option
  function updateVariantId(select, variantInput, atcButton, atcText) {
    const selectedValue = select.value;
    const variantsData = select.dataset.variants;
    
    if (!variantsData || !variantInput) return;
    
    try {
      const variants = JSON.parse(variantsData);
      const matchedVariant = variants.find(v => v.options.includes(selectedValue));
      
      if (matchedVariant) {
        variantInput.value = matchedVariant.id;
        
        // Update button state based on availability
        if (atcButton && atcText) {
          if (matchedVariant.available) {
            atcButton.disabled = false;
            atcButton.removeAttribute('aria-disabled');
            atcText.textContent = 'Add';
          } else {
            atcButton.disabled = true;
            atcButton.setAttribute('aria-disabled', 'true');
            atcText.textContent = 'Sold Out';
          }
        }
      }
    } catch (err) {
      console.error('Error parsing variants:', err);
    }
  }

  // Handle color sphere clicks to change product variant
  const colorSpheres = upsellsContainer.querySelectorAll('.product-upsell-card__color-sphere');
  
  colorSpheres.forEach((sphere) => {
    sphere.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const card = sphere.closest('.product-upsell-card');
      if (!card) return;
      
      const newImage = sphere.dataset.image;
      const newUrl = sphere.dataset.url;
      const newPrice = sphere.dataset.price;
      const newTitle = sphere.dataset.title;
      
      // Extract product handle from URL
      const urlParts = newUrl.split('/products/');
      const newProductHandle = urlParts[1] ? urlParts[1].replace(/\/$/, '') : null;
      
      if (!newProductHandle) return;
      
      // Update image
      const cardImage = card.querySelector('.product-upsell-card__image');
      if (cardImage && newImage) {
        cardImage.src = newImage;
        cardImage.srcset = newImage;
      }
      
      // Update links
      const imageLink = card.querySelector('.product-upsell-card__image-link');
      const titleLink = card.querySelector('.product-upsell-card__title-link');
      if (imageLink && newUrl) imageLink.href = newUrl;
      if (titleLink && newUrl) titleLink.href = newUrl;
      
      // Update price
      const priceRegular = card.querySelector('.product-upsell-card__price--regular');
      const priceSale = card.querySelector('.product-upsell-card__price--sale');
      if (priceRegular && newPrice) priceRegular.textContent = newPrice;
      if (priceSale && newPrice) priceSale.textContent = newPrice;
      
      // Update title if variant title is shown separately
      const variantTitle = card.querySelector('.variant___title');
      if (variantTitle && newTitle) variantTitle.textContent = newTitle;
      
      // Update card data attributes
      card.dataset.productHandle = newProductHandle;
      card.dataset.productUrl = newUrl;
      
      // Fetch new product data and update form
      fetch(`/products/${newProductHandle}.js`)
        .then(response => response.json())
        .then(product => {
          const variantInput = card.querySelector('.product-upsell-card__variant-input');
          const variantSelect = card.querySelector('.product-upsell-card__variant-select');
          const atcButton = card.querySelector('.product-upsell-card__atc-button');
          const atcText = card.querySelector('.product-upsell-card__atc-text');
          const variantSelector = card.querySelector('.product-upsell-card__variant-selector');
          
          // Update card product ID
          card.dataset.productId = product.id;
          
          // Get first available variant
          const firstAvailableVariant = product.variants.find(v => v.available) || product.variants[0];
          
          // Update hidden variant input
          if (variantInput) {
            variantInput.value = firstAvailableVariant.id;
          }
          
          // Update variant dropdown if it exists
          if (variantSelect && product.options && product.options.length > 0) {
            const firstOption = product.options[0];
            
            // Store variants data on select
            variantSelect.dataset.variants = JSON.stringify(product.variants);
            variantSelect.dataset.productId = product.id;
            
            // Check if product has more than one option value
            if (firstOption.values && firstOption.values.length > 1) {
              // Clear and rebuild dropdown
              variantSelect.innerHTML = '';
              
              firstOption.values.forEach((value, valueIndex) => {
                // Skip the sold-out Color/Finish placeholder variant (belts use it as the swatch name) so it never shows under "Size:"
                if (valueIndex === 0 && firstOption.name === 'Color/Finish' && !product.variants.some(v => v.options.includes(value) && v.available)) return;
                const option = document.createElement('option');
                option.value = value;
                option.textContent = value;
                
                // Check if this option value has any available variants
                const hasAvailableVariant = product.variants.some(v => 
                  v.options.includes(value) && v.available
                );
                
                if (!hasAvailableVariant) {
                  option.disabled = true;
                  option.textContent = value + ' - Sold Out';
                }
                
                // Select first available option
                if (firstAvailableVariant.options.includes(value)) {
                  option.selected = true;
                }
                
                variantSelect.appendChild(option);
              });
              
              // Show variant selector if hidden
              if (variantSelector) {
                variantSelector.style.display = 'flex';
              }
            } else {
              // Hide selector if only one option
              if (variantSelector) {
                variantSelector.style.display = 'none';
              }
            }
          } else if (product.variants.length === 1) {
            // Hide selector for products with only default variant
            if (variantSelector) {
              variantSelector.style.display = 'none';
            }
          }
          
          // Update ATC button state
          if (atcButton && atcText) {
            if (firstAvailableVariant.available) {
              atcButton.disabled = false;
              atcButton.removeAttribute('aria-disabled');
              atcText.textContent = 'Add';
            } else {
              atcButton.disabled = true;
              atcButton.setAttribute('aria-disabled', 'true');
              atcText.textContent = 'Sold Out';
            }
          }
        })
        .catch(err => console.error('Error fetching new product:', err));
      
      // Track analytics
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'upsell_color_change',
          'upsell_variant': newTitle
        });
      }
    });
  });

  // Track product link clicks (image and title)
  const productLinks = upsellsContainer.querySelectorAll('.product-upsell-card__image-link, .product-upsell-card__title-link');
  
  productLinks.forEach((link, index) => {
    link.addEventListener('click', () => {
      if (window.dataLayer) {
        const card = link.closest('.product-upsell-card');
        const productTitle = card?.querySelector('.product-upsell-card__title')?.textContent || '';
        window.dataLayer.push({
          'event': 'upsell_product_click',
          'upsell_product': productTitle,
          'upsell_position': Math.floor(index / 2) + 1
        });
      }
    });
  });

  // Optional: Add lazy loading observer for images if needed
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    });

    const lazyImages = upsellsContainer.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => imageObserver.observe(img));
  }
});
